<div appTrapFocus appAutoFocusModal appRefocusPreviousEl role="dialog" aria-labelledby="complete-testdrive-head"
  aria-describedby="complete-testdrive-desc">
  <div class="modal-header" id="complete-testdrive-head">
    <h4 class="modal-title pull-left"> {{ title }} </h4>
    <!--    <button type="button" class="close pull-right" aria-label="Close" (click)="onClose()">-->
    <!--      <span aria-hidden="true">&times;</span>-->
    <!--    </button>-->
  </div>
  <div class="modal-body" id="complete-testdrive-desc">
    <p>{{data.description}}</p>
  </div>
  <div class="modal-footer">
    <teams-button [classList]="'btn ts-btn-fluent-white modal-close-button'" (buttonClick)="onClose()">
      {{data.failureButtonText}}</teams-button>
    <teams-button [classList]="'btn ts-btn-fluent-primary modal-ok-button'" (buttonClick)="onConfirm()">
      {{data.successButtonText}}</teams-button>
  </div>
</div>